import { useEntityDetailsProps } from '../use-entity-details-props/use-entity-details-props';
import { getFullEntityDataPath } from '../../utils/get-full-entity-data-path/get-full-entity-data-path';

/**
 * Read the current entity-details context and return the full dot-notation
 * path from entity-data root down to the given property path. Wraps
 * `getFullEntityDataPath` with the context the consumer doesn't need to
 * pass in.
 */
export const useFullEntityDataPath = (propertyPath: string): string => {
  const { formPath, isUsingConfigAppBackend } = useEntityDetailsProps();
  return getFullEntityDataPath(
    formPath,
    propertyPath,
    Boolean(isUsingConfigAppBackend),
  );
};
